import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LineProgressMetricData } from "../../../../services/analytics/assets.analytics";
import { AppThunk } from "../../..";

const lineProgressInitialState:Partial<LineProgressMetricData>   = {}
export const lineProgressMetrics = createSlice({
  name: "lineProgressMetrics",
  initialState:lineProgressInitialState,
  reducers: {
    update: (_state, action: PayloadAction<LineProgressMetricData>) => {
      return action.payload;
    },
  },
});
export const { update } = lineProgressMetrics.actions;
export const updateLineProgressMetrics=(data:LineProgressMetricData):AppThunk=>  (dispatch)=>{
  dispatch(update(data));
}
export default lineProgressMetrics.reducer;

